const DeriveAbilityModifier = (score) => Math.floor((score - 10) / 2);

export default DeriveAbilityModifier;

